import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import QRCode from "react-qr-code";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  Divider,
  Grid,
  Tooltip,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const copyToClipboard = async (value) => {
  await navigator.clipboard.writeText(value);
  alert("Copiado");
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxWidth: "95%",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

function DashboardTableInvoice({
  openOneClickInvoice,
  closeModalopenOneClickInvoice,
  invoice,
}) {
  return (
    <Modal open={openOneClickInvoice} onClose={closeModalopenOneClickInvoice}>
      <Box sx={style}>
        {invoice?.status && (
          <>
            <Typography variant="h6" align="center" gutterBottom>
              Sua fatura está {invoice.status["name"]}
            </Typography>
            {invoice.charges_types && <ShowBoleto invoice={invoice} />}
          </>
        )}
      </Box>
    </Modal>
  );
}

const ShowBoleto = ({ invoice }) => {
  const [boleto, setBoleto] = useState({});
  const [qrCodePix, setQrCodePix] = useState({});

  useEffect(() => {
    if (invoice?.boleto) {
      setBoleto(invoice.boleto);
      setQrCodePix(invoice.pix);
    }
  }, [invoice]);

  return (
    <Box mt={3}>
      <Typography variant="body1" gutterBottom>
        <strong>Data de vencimento:</strong>{" "}
        {new Date(invoice.due_date).toLocaleDateString()}
      </Typography>
      <Typography variant="body1" gutterBottom>
        <strong>Valor:</strong>{" "}
        {parseFloat(invoice.amount || 0).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })}
      </Typography>

      {qrCodePix?.qrcode && (
        <>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" gutterBottom>
            Pague com Pix para compensação imediata
          </Typography>
          <Typography variant="body2" gutterBottom>
            Escaneie o QR Code abaixo ou copie o código Pix.
          </Typography>

          <Box display="flex" justifyContent="center" my={2}>
            <QRCode value={qrCodePix.qrcode} size={180} />
          </Box>

          <Grid container spacing={1} alignItems="center">
            <Grid item xs={11}>
              <TextField
                label="Pix Copia e Cola"
                value={qrCodePix.qrcode}
                fullWidth
                InputProps={{ readOnly: true }}
                onClick={() => copyToClipboard(qrCodePix.qrcode)}
              />
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Copiar Pix">
                <IconButton
                  color="primary"
                  onClick={() => copyToClipboard(qrCodePix.qrcode)}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>

          {qrCodePix.url_slip && (
            <Box mt={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                href={qrCodePix.url_slip}
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir Pix em nova aba
              </Button>
            </Box>
          )}

          {qrCodePix.url_slip_pdf && (
            <Box mt={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                href={qrCodePix.url_slip_pdf}
                target="_blank"
                rel="noopener noreferrer"
              >
                Baixar PDF do Pix
              </Button>
            </Box>
          )}
        </>
      )}

      {boleto?.barcode && (
        <>
          <Divider sx={{ my: 3 }} />
          <Typography variant="subtitle1" gutterBottom>
            Prefere pagar via Boleto?
          </Typography>

          <Typography variant="body2" gutterBottom>
            Copie o código de barras ou baixe o boleto.
          </Typography>

          <Grid container spacing={1} alignItems="center">
            <Grid item xs={11}>
              <TextField
                label="Código de Barras"
                value={boleto.barcode}
                fullWidth
                InputProps={{ readOnly: true }}
                onClick={(e) => copyToClipboard(boleto.barcode)}
              />
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Copiar Boleto">
                <IconButton
                  color="primary"
                  onClick={() => copyToClipboard(boleto.barcode)}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>

          {invoice?.link && (
            <Box mt={2}>
              <Button
                variant="outlined"
                fullWidth
                href={invoice.link}
                target="_blank"
              >
                Abrir Boleto
              </Button>
            </Box>
          )}
          {boleto.url_slip_pdf && (
            <Box mt={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                href={boleto.url_slip_pdf}
                target="_blank"
                rel="noopener noreferrer"
              >
                Baixar PDF do Boleto
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default DashboardTableInvoice;
